// for Safari < 15.4
import 'core-js/es/object/has-own';